import { applySpec, prop } from "ramda"

/** @enum */
export const Contract = {
	TEXT: 'TEXT',
	VALUE: 'VALUE',
}

export default applySpec({
  text: prop(Contract.TEXT),
  value: prop(Contract.VALUE),
});
